@let way = communicationWay();
@let contactValue = contact();

<app-form-wrapper [title]="'login.card_bg' | translate">
  <div class="md_mt-lg"></div>
  @let currentStep = step();
  @if (currentStep === 1) {
    <div class="form-step-1 flex-col align-items-start md_flex-row md_align-items-center">
      <button mat-raised-button
              color="primary"
              (click)="handleCodeGet()">{{ 'login.get_code' | translate }}
      </button>
      @if (way === CommunicationWay.EMAIL) {
        <span>{{ 'login.send_method_email' | translate }}</span>
      }
      @if (way === CommunicationWay.SMS) {
        <span>{{ 'login.send_method_sms' | translate }}</span>
      }
    </div>
  }
  @if (currentStep === 2) {
    <div class="form-step-2">
      <div class="explanation-section">
        @if (way === CommunicationWay.EMAIL) {
          <span>{{ 'login.enter_code_from_email' | translate:({contact: contactValue}) }}</span>
        }
        @if (way === CommunicationWay.SMS) {
          <span>{{ 'login.enter_code_from_sms' | translate:({contact: contactValue}) }}</span>
        }
      </div>
      <div class="code-wrapper">
        <input [formControl]="codeControl"
               matInput
               class="code-input"
               [placeholder]="'login.send_code_placeholder' | translate"
               [class.is-invalid]="codeControl.invalid"/>
        <button mat-raised-button
                color="primary"
                class="code-button"
                (click)="handleLogin()">
          {{ 'login.send_code' | translate }}
        </button>
      </div>
      <div class="code-request-repeat">
        {{ 'login.did_not_get_code' | translate }}
        @let cooldownSeconds = cooldown();
        @if (cooldownSeconds > 0) {
          <span>{{ 'login.try_again_cooldown' | translate: ({cooldown: cooldownSeconds}) }}</span>
        } @else {
          <span class="link-action"
                (click)="handleTryAgain()"
                (keydown.enter)="handleTryAgain()">{{ 'login.try_again' | translate }}</span>
        }
      </div>
    </div>
  }
</app-form-wrapper>
